import { useMemo, useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useTranslation } from "react-i18next";
import "./CountryPhoneInput.css";

const PREFERRED_COUNTRIES = [
  "tn",
  "fr",
  "it",
  "de",
  "es",
  "pt",
  "gb",
  "us",
  "ma",
  "dz",
  "ae",
  "sa",
  "be",
  "ch",
  "nl",
];

function isoToFlagEmoji(iso2) {
  const code = String(iso2 || "").trim().toUpperCase();
  if (code.length !== 2) return "";
  return String.fromCodePoint(...[...code].map((c) => 127397 + c.charCodeAt(0)));
}

function digitsOnly(value) {
  return String(value || "").replace(/[^\d]/g, "");
}

export default function CountryPhoneInput({
  value,
  onChange,
  defaultCountry = "tn",
  placeholder = "+216 12 345 678",
  inputClassName = "form-control",
  inputStyle,
  inputProps,
  disabled = false,
}) {
  const { t } = useTranslation();
  const [selected, setSelected] = useState({
    name: "",
    dialCode: "",
    countryCode: "",
  });

  const phoneValue = useMemo(() => digitsOnly(value), [value]);

  return (
    <div className="country-phone-input">
      <PhoneInput
        country={defaultCountry}
        value={phoneValue}
        enableSearch
        disableSearchIcon={false}
        disableCountryGuess={false}
        countryCodeEditable={false}
        preferredCountries={PREFERRED_COUNTRIES}
        placeholder={placeholder}
        disabled={disabled}
        inputClass={inputClassName}
        buttonClass="country-phone-input__flag-btn"
        dropdownClass="country-phone-input__dropdown"
        containerClass="country-phone-input__wrap"
        searchPlaceholder={t("phoneCountrySearch", {
          defaultValue: "Search country name or code…",
        })}
        onChange={(nextValue, country) => {
          setSelected({
            name: country?.name || "",
            dialCode: country?.dialCode || "",
            countryCode: country?.countryCode || "",
          });
          onChange?.(nextValue || "", country);
        }}
        inputProps={{
          ...inputProps,
          style: {
            width: "100%",
            height: "48px",
            ...(inputStyle || {}),
          },
        }}
      />
      {selected.name ? (
        <div className="country-phone-input__meta">
          <span className="country-phone-input__flag" aria-hidden>
            {isoToFlagEmoji(selected.countryCode)}
          </span>
          <span>
            {selected.name}{" "}
            <strong>+{selected.dialCode}</strong>
          </span>
        </div>
      ) : null}
    </div>
  );
}
